export const DEFAULT_BACKGROUND_COLOR = "#1a1a1a"
export const DEFAULT_TEXT_COLOR = "#ffffff"
